import { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { KTSVG } from '../../../_metronic/helpers'
import { DeleteModal } from '../../components/modals/DeleteModal'
import { MissionListModal } from './_modals/MissionListModal'
import { MissionFormModal } from './_modals/MissionFormModal'
import MissionApi from '../../../infrastructure/api/MissionApi'
import { RootState } from '../../../setup'
import { shallowEqual, useSelector } from 'react-redux'
import { UserModel } from '../../modules/auth/models/UserModel'

const MissionPage: FC = () => {
  const [itemId, setItemId] = useState('')
  const [itemName, setItemName] = useState('')
  const [showDelete, setShowDelete] = useState(false)
  const handleCloseDelete = () => setShowDelete(false)
  const handleShowDelete = () => setShowDelete(true)

  const [refresh, setRefresh] = useState<number>(0)
  const [showForm, setShowForm] = useState(false)
  const handleCloseForm = () => { setShowForm(false); setRefresh(refresh + 1) }
  const handleShowForm = () => setShowForm(true)

  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel


  const onClickItem = (value: string, name: string, type: string) => {
    setItemId(value)
    setItemName(name)
    switch (type) {
      case 'delete':
        handleShowDelete()
        break
      default:
        handleShowForm()
        break
    }
  }

  async function deleteMission(itemId: string) {
    if (user.companyId) {
      var response = await MissionApi.DeleteMission(itemId, user.companyId)
      setRefresh(refresh + 1)
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'></h3>
          <div
            className='card-toolbar'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='hover'
            title='Click to add a Mission'
          >
            <a
              href='#'
              onClick={() => onClickItem('', '', 'create')}
              className='btn btn-sm btn-light-primary'
            >
              <i className="fas fa-plus"></i>
              Add Mission
            </a>
          </div>
        </div>

        <div className='card-body py-3'>
          <MissionListModal refresh={refresh} onClickItem={onClickItem} />
          {user.companyId && <MissionFormModal companyId={user.companyId} itemId={itemId} show={showForm} handleClose={handleCloseForm} />}
          <DeleteModal
            itemId={itemId}
            itemName={itemName}
            handleClose={handleCloseDelete}
            show={showDelete}
            type='Mission'
            confirm={deleteMission}
          />
        </div>
      </div>
    </>
  )
}

const MissionWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>Mission</PageTitle>
      <MissionPage />
    </>
  )
}

export { MissionWrapper }
